import * as React from 'react';
import { useFiltersContext } from '../../contexts/filters';

const SiteToggle = () => {
	const { siteFilter, setSiteFilter } = useFiltersContext();

	const handleToggle = (value: string) => {
		if (setSiteFilter) {
			setSiteFilter(value);
		}
	};

	return (
		<div className="pfa-site-toggle">
			<fieldset className="pfa-site-toggle__fieldset">
				<div className="pfa-site-toggle__options">
					<label className="pfa-site-toggle__option" htmlFor="site-filter-all">
						<input
							type="radio"
							name="site-filter"
							id="site-filter-all"
							value="all"
							checked={siteFilter === 'all'}
							onChange={() => handleToggle('all')}
							className="pfa-site-toggle__input"
						/>
						<span className="pfa-site-toggle__label">All Sites</span>
					</label>
					<label className="pfa-site-toggle__option" htmlFor="site-filter-current">
						<input
							type="radio"
							name="site-filter"
							id="site-filter-current"
							value="current"
							checked={siteFilter === 'current'}
							onChange={() => handleToggle('current')}
							className="pfa-site-toggle__input"
						/>
						<span className="pfa-site-toggle__label">This site only</span>
					</label>
				</div>
			</fieldset>
		</div>
	);
};

SiteToggle.displayName = 'SiteToggle';

export default SiteToggle;
